import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, EffectFade } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";

const slides = [
  {
    id: 1,
    title: "Exceptional Education. Exceptional Value.",
    description:
      "The first thing to remember about success is that it is a process nothing more, nothing less. There is really no magic to it and it’s not reserved only for a select few people.",
    image: "images/banner/slide-7.png",
    buttons: [
      // { text: "Read More", className: "btn-white", link: "#" },
      { text: "Contact Us", className: "btn-primary", link: "#" },
    ],
  },
  {
    id: 2,
    title: "The Education You Want. The Attention You Deserve",
    description:
      "There are basically six key areas to higher achievement. Some people will tell you there are four while others may tell you there are eight.",
    image: "images/banner/slide-2.png",
    buttons: [{ text: "Contact Us", className: "btn-primary", link: "#" }],
  },
  {
    id: 3,
    title: "The Education You Want. The Attention You Deserve",
    description:
      "There are basically six key areas to higher achievement. Some people will tell you there are four while others may tell you there are eight.",
    image: "images/banner/slider_new.png",
    buttons: [{ text: "Contact Us", className: "btn-primary", link: "#" }],
  },
  {
    id: 4,
    title: "The Education You Want. The Attention You Deserve",
    description:
      "There are basically six key areas to higher achievement. Some people will tell you there are four while others may tell you there are eight.",
    image: "images/banner/slide-4.png",
    buttons: [{ text: "Contact Us", className: "btn-primary", link: "#" }],
  },
  {
    id: 5,
    title: "The Education You Want. The Attention You Deserve",
    description:
      "There are basically six key areas to higher achievement. Some people will tell you there are four while others may tell you there are eight.",
    image: "images/banner/slide-5.png",
    buttons: [{ text: "Contact Us", className: "btn-primary", link: "#" }],
  },
  {
    id: 6,
    title: "The Education You Want. The Attention You Deserve",
    description:
      "There are basically six key areas to higher achievement. Some people will tell you there are four while others may tell you there are eight.",
    image: "images/banner/slide-6.png",
    buttons: [{ text: "Contact Us", className: "btn-primary", link: "#" }],
  },
];

export default function SwiperSlider() {
  const handleButtonClick = (text) => {
    console.log(`${text} button clicked!`);
    // Add your navigation or other logic here
  };

  return (
    <section className="banner relative">
      <Swiper
        modules={[Navigation, Autoplay, EffectFade]}
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        effect="fade"
        loop
        className="swiper-container h-600 h-lg-600 h-md-600 h-sm-400"
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div
              className="swiper-slide align-items-center d-flex bg-overlay-black-40"
              style={{
                backgroundImage: `url(${slide.image})`,
                pointerEvents: "none", backgroundPosition:'center center', objectFit:'cover'
              }}
            >
              <div className="swipeinner container pointer-events-auto">
                <div className="row justify-content-center text-center">
                  <div className="col-lg-10 col-md-12">
                    <div className="slider-1">
                      <div
                        className="animated"
                        data-swiper-animation="fadeInUp"
                        data-duration="1s"
                        data-delay="0.25s"
                      >
                        {/* <h1 className="text-white mb-4">{slide.title}</h1> */}
                        <div
                          className="text-white px-0 lg:px-20"
                          data-swiper-animation="fadeInUp"
                          data-duration="2.5s"
                          data-delay="0.25s"
                        >
                          {/* <p className="text-white hidden sm:block">
                            {slide.description}
                          </p> */}
                        </div>
                        {/* <div className="btn-group mt-4 z-10 pointer-events-auto">
                          {slide.buttons.map((btn, idx) => (
                            <a
                              key={idx}
                              href={btn.link}
                              className={`btn ${btn.className} mx-2 px-4 py-2 rounded transition-colors duration-300 hover:opacity-90`}
                              onClick={() => handleButtonClick(btn.text)}
                              style={{ pointerEvents: "auto" }}
                            >
                              {btn.text}
                            </a>
                          ))}
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Navigation Buttons */}
      <div className="swiper-button-prev bg-transparent text-white z-20">
        <i className="fa fa-arrow-left"></i>
      </div>
      <div className="swiper-button-next bg-transparent text-white z-20">
        <i className="fa fa-arrow-right"></i>
      </div>

      {/* Inline CSS for button styles */}
      
    </section>
  );
}